import {useEffect, useRef, useState} from 'react';

 const useDebounce = (value: any, delay: number) => {
    const [debouncedValue, setDebouncedValue] = useState<any>();
    let timer: any = useRef();

    const Cancel = () => {
        clearTimeout(timer.current);
        timer.current = null;
        setDebouncedValue(value);
    }

    useEffect(() => {
        timer.current = setTimeout(() => setDebouncedValue(value), delay ?? 500);
        return () => clearTimeout(timer.current);
    }, [value, delay]);

    return {debouncedValue, Cancel}
}

export default useDebounce